document.addEventListener("DOMContentLoaded", () => {
    function makeItWork(parentEl) {
        let allCustomFaqTabs = parentEl.querySelectorAll(".custom-faq-tab");
        let allCustomTabImages = parentEl.querySelectorAll(".ss-tab-img");
        allCustomFaqTabs.forEach((el) => {
            el.addEventListener("click", () => {
                let blockId = el.getAttribute("data-block-id");
                allCustomTabImages.forEach((imgEl) => {
                    imgEl.classList.remove("active");
                    if (imgEl.getAttribute("data-block-id") == blockId) {
                        imgEl.classList.add("active");
                    }
                })
            })
        })
    }
    let allCustomTabsSection = document.querySelectorAll(".custom-ss-tabs-section");
    allCustomTabsSection.forEach((el) => {
        makeItWork(el);
    })
})
